import React from "react"
import { Card as AntCard } from "antd"

type Props = {
  children: React.ReactNode
  title: string
}

export const Card: React.FC<Props> = ({ children, title }) => (
  <AntCard title={title} bordered={false} style={{ width: 300 }}>
    {children}
  </AntCard>
)
